const latLng = {
  namespaced: true,
  state: {
    lat: '',
    lng: ''
  },
  getters: {
    getLat: (state) => state.lat,
    getLng: (state) => state.lng
  },
  mutations: {
    setLat (state, lat) {
      state.lat = lat
    },
    setLng (state, lng) {
      state.lng = lng
    }
  },
  actions: {
    setLat ({ commit }, lat) {
      commit('setLat', lat)
    },
    setLng ({ commit }, lng) {
      commit('setLng', lng)
    }
  }
}

export default latLng



// WEBPACK FOOTER //
// ./src/vuex/saveLatLng.js